import { SET_WORKSPACE } from "../actions/WorkspaceActions";

const initialState = {
  workspace: localStorage.getItem("workspace") || "STB",
};

const WorkspaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WORKSPACE:
      return { ...state, workspace: action.payload };
    default:
      return state;
  }
};

export default WorkspaceReducer;
